/**
 * CS Collection — View Toggle + Filter Drawer proxy
 * cafesociete.com
 */

class CSViewToggle {
  constructor() {
    this.gridContainer = document.getElementById('ProductGridContainer');
    this.grid = document.getElementById('product-grid');
    this.buttons = document.querySelectorAll('.cs-view-btn');
    // Migrate old "6" value to "5"
    let saved = localStorage.getItem('cs-collection-view') || '3';
    if (saved === '6') saved = '5';
    this.savedView = saved;

    if (!this.grid || !this.buttons.length) return;

    this.init();
  }

  init() {
    // Set saved view on load
    this.setView(this.savedView);

    // Button click listeners
    this.buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        this.setView(btn.dataset.columns);
      });
    });

    // MutationObserver: Dawn's facets.js replaces grid HTML via AJAX
    // When that happens, grid classes reset — we need to re-apply our view
    if (this.gridContainer) {
      const observer = new MutationObserver(() => {
        // Re-grab grid element (it gets replaced)
        this.grid = document.getElementById('product-grid');
        if (this.grid) {
          const currentView = localStorage.getItem('cs-collection-view') || '3';
          this.applyGridClass(currentView);
        }
      });

      observer.observe(this.gridContainer, {
        childList: true,
        subtree: true
      });
    }
  }

  setView(columns) {
    this.applyGridClass(columns);

    // Update active state on buttons
    this.buttons.forEach(btn => {
      btn.classList.toggle('cs-view-btn--active', btn.dataset.columns === columns);
    });

    // Persist in localStorage
    localStorage.setItem('cs-collection-view', columns);
  }

  applyGridClass(columns) {
    if (!this.grid) return;
    // Remove all possible column classes
    this.grid.classList.remove(
      'grid--1-col-desktop',
      'grid--2-col-desktop',
      'grid--3-col-desktop',
      'grid--4-col-desktop',
      'grid--5-col-desktop',
      'grid--6-col-desktop'
    );
    // Add the chosen one
    this.grid.classList.add(`grid--${columns}-col-desktop`);
  }
}

// Size-label map: full Shopify names → short codes
const sizeMap = {
  'Extra small (XS)': 'XS',
  'Small (S)': 'S',
  'Medium (M)': 'M',
  'Large (L)': 'L',
  'Extra large (XL)': 'XL'
};

// Re-usable: apply all drawer DOM customisations.
// Called once on init AND again every time Dawn replaces drawer content via AJAX.
function applyDrawerCustomisations(menuDrawer, closeDrawer) {
  // Rename heading → "Filtry"
  menuDrawer.querySelectorAll('.mobile-facets__heading').forEach(h => {
    h.textContent = 'Filtry';
  });

  // Shorten size labels
  menuDrawer.querySelectorAll('.facets-layout-list--text .facet-checkbox__text-label').forEach(lbl => {
    const short = sizeMap[lbl.textContent.trim()];
    if (short) lbl.textContent = short;
  });

  // Move footer out of .mobile-facets__main → direct child of .mobile-facets__inner
  const inner = menuDrawer.querySelector('.mobile-facets__inner');
  const mainFooter = menuDrawer.querySelector('.mobile-facets__main > .mobile-facets__footer');
  if (inner && mainFooter) {
    inner.appendChild(mainFooter);
  }

  // Inject close button into .mobile-facets__inner (if not already present)
  // Positioned absolutely to align vertically with the first accordion + icon
  if (inner && !inner.querySelector('.cs-drawer-close')) {
    const closeBtn = document.createElement('button');
    closeBtn.className = 'cs-drawer-close';
    closeBtn.setAttribute('type', 'button');
    closeBtn.setAttribute('aria-label', 'Close filters');
    closeBtn.textContent = '\u00D7';
    inner.appendChild(closeBtn);
    closeBtn.addEventListener('click', closeDrawer);
  }
}

// Filter drawer proxy — open/close Dawn's drawer from our custom button
function initFilterProxy() {
  const filterBtn = document.getElementById('cs-filter-trigger');
  if (!filterBtn) return;

  const menuDrawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
  if (!menuDrawer) return;

  // Move menu-drawer to <body> level.
  // Dawn renders it inside <main>, but ancestors of <main> create a containing
  // block that breaks position:fixed on .mobile-facets (it starts at ~89px
  // instead of viewport top). Moving to <body> fixes this.
  document.body.appendChild(menuDrawer);

  const details = menuDrawer.querySelector('details.mobile-facets__disclosure');
  const summary = menuDrawer.querySelector('summary');
  if (!details) return;

  // .mobile-facets is the dark overlay (position:fixed, covers viewport).
  // .mobile-facets__inner (white panel) lives inside it — no z-index conflicts.
  const mobileFacets = document.querySelector('.mobile-facets');

  // Close drawer when clicking the dark overlay area (outside the white panel)
  if (mobileFacets) {
    mobileFacets.addEventListener('click', (e) => {
      if (e.target === mobileFacets) {
        closeDrawer();
      }
    });
  }

  // Persistent scroll position — saved once when drawer opens,
  // restored on ANY close (our button, Dawn's ZASTOSUJ, Usuń, ×, Escape).
  let savedScrollY = 0;

  // Temporarily intercept ALL scroll events and pin the viewport.
  // Dawn's closeMenuDrawer() focuses the <summary> at the bottom of <body>,
  // which causes the browser to scroll there. This blocks that entirely.
  function lockScrollDuringClose() {
    const target = savedScrollY;
    function pin() { window.scrollTo(0, target); }
    window.addEventListener('scroll', pin);
    // Release lock after Dawn's close + AJAX settles
    setTimeout(() => window.removeEventListener('scroll', pin), 400);
  }

  function openDrawer() {
    savedScrollY = window.scrollY;
    document.body.classList.add('overflow-hidden');
    details.setAttribute('open', '');
    if (typeof menuDrawer.openMenuDrawer === 'function') {
      menuDrawer.openMenuDrawer(summary);
    }
    window.scrollTo(0, savedScrollY);
  }

  function closeDrawer() {
    lockScrollDuringClose();
    if (typeof menuDrawer.closeMenuDrawer === 'function') {
      menuDrawer.closeMenuDrawer();
    }
    details.removeAttribute('open');
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile');
    window.scrollTo(0, savedScrollY);
  }

  // Apply customisations on first load
  applyDrawerCustomisations(menuDrawer, closeDrawer);

  // MutationObserver: Dawn's facets.js replaces drawer inner HTML via AJAX
  // when a filter is applied. Re-apply our DOM tweaks after each such update.
  const drawerMain = menuDrawer.querySelector('.mobile-facets__main');
  if (drawerMain) {
    let debounceTimer = null;
    const drawerObserver = new MutationObserver(() => {
      // Debounce: Dawn may fire multiple mutations in quick succession
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        applyDrawerCustomisations(menuDrawer, closeDrawer);
      }, 80);
    });
    drawerObserver.observe(drawerMain, { childList: true, subtree: true });
  }

  // Open on our custom FILTER button click
  filterBtn.addEventListener('click', openDrawer);

  // Close on Escape key
  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape' && details.hasAttribute('open')) {
      closeDrawer();
    }
  });

  // Sync: catch ANY drawer close (Dawn's ZASTOSUJ, Usuń wszystko, etc.)
  // and lock scroll + clean up body class.
  const closeObserver = new MutationObserver(() => {
    if (!details.hasAttribute('open')) {
      lockScrollDuringClose();
      document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile');
    }
  });
  closeObserver.observe(details, { attributes: true, attributeFilter: ['open'] });
}

// Init on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  new CSViewToggle();
  initFilterProxy();
});
